import React, { Component } from 'react'
import { Table, DatePicker, Button, message } from 'antd'
import moment from 'moment'
import { toHourMinuteSecond, clickDownload } from '../../../../util/index'
import { attendanceDayRecord } from '../../../../api/employee'
const { RangePicker } = DatePicker

const nowDate = new Date()
nowDate.setMonth(nowDate.getMonth() - 1)
nowDate.setDate(1)
nowDate.setHours(0, 0, 0, 0)
const nextDate = new Date()
nextDate.setMonth(nowDate.getMonth() + 1, 0)
nextDate.setHours(0, 0, 0, 0)

export default class dayTable extends Component {
  state = {
    isloading: true,
    pickerValue: [
      moment(nowDate, 'YYYY-MM-DD'),
      moment(nextDate, 'YYYY-MM-DD'),
    ],
    hackValue: null,
    dates: [],
    list: [],
  }

  componentDidMount() {
    this.getDatas()
  }

  getDatas = async () => {
    const sTime = moment(this.state.pickerValue[0])
    const eTime = moment(this.state.pickerValue[1])
    sTime.startOf('day')
    eTime.add(1, 'days')
    const { status, detail, data } = await attendanceDayRecord({
      startTimestamp: sTime.unix(),
      endTimestamp: eTime.unix(),
    })
    this.setState({
      isloading: false,
    })
    if (status != 1) {
      message.error(detail)
      return
    }
    const dataAry = [].concat(data)
    if (dataAry && dataAry.length > 0) {
      const newData = dataAry.map((item) => {
        const { employee, attendance } = item
        const { hour, minute, second } = toHourMinuteSecond(attendance.duration)
        return {
          employeeId: employee.id, // 员工id
          attendanceId: attendance.id, // 考勤记录ID
          name: employee.name, // 员工名称
          punchInDate:
            attendance.punchInStatus >= 5 || attendance.punchInStatus == 0
              ? ''
              : moment(attendance.punchInTime).format('YYYY-MM-DD HH:mm:ss'), // 上班打卡
          punchOutDate:
            attendance.punchOutStatus >= 5 || attendance.punchOutStatus == 0
              ? ''
              : moment(attendance.punchOutTime).format('YYYY-MM-DD HH:mm:ss'), // 下班打卡
          punchInPosition: attendance.punchInPosition,
          punchOutPosition: attendance.punchOutPosition,
          attendanceDate: moment(attendance.attendanceTime).format(
            'YYYY-MM-DD'
          ), //考勤日期
          punchInStatus: this.workStatus(attendance.punchInStatus), //上班打卡状态：1.完成，2.迟到，3.早退，4.地址异常，5.缺勤，6.休假
          punchOutStatus: this.workStatus(attendance.punchOutStatus), //下班打卡状态：同上
          duration: `${hour}小时${minute}分钟`, //单日总时长
        }
      })
      this.setState({
        list: newData,
      })
    } else {
      this.setState({
        list: [],
      })
    }
  }

  onChange = (value, dateString) => {
    if (!value) {
      return
    }
    this.setState({
      pickerValue: value,
    })
  }

  onOpenChange = (open) => {
    if (open) {
      this.setState({
        dates: [],
        hackValue: [],
      })
    } else {
      this.setState({
        hackValue: undefined,
      })
    }
  }

  onCalendarChange = (val) => {
    this.setState({
      dates: val,
    })
  }

  disabledDate = (current) => {
    if (!this.state.dates || this.state.dates.length === 0) {
      return false || current >= moment()
    }
    // 控制选择范围在30天内
    const tooLate =
      this.state.dates[0] && current.diff(this.state.dates[0], 'days') > 30
    const tooEarly =
      this.state.dates[0] && this.state.dates[0].diff(current, 'days') > 30
    return tooLate || tooEarly || current >= moment()
  }

  onSearchEvent = () => {
    if (this.state.isloading) {
      return
    }
    this.setState({ isloading: true }, this.getDatas)
  }

  workStatus = (status) => {
    let text = '正常'
    switch (status) {
      case 0:
        text = ''
        break
      case 1:
        text = '正常'
        break
      case 2:
        text = '迟到'
        break
      case 3:
        text = '早退'
        break
      case 4:
        text = '地址异常'
        break
      case 5:
        text = '缺勤'
        break
      case 6:
        text = '休假'
        break
      default:
        break
    }
    return text
  }

  render() {
    const { isloading, list, hackValue, pickerValue } = this.state
    const dateString = pickerValue
      ? `${pickerValue[0].format('YYYY-MM-DD')}-${pickerValue[1].format(
          'YYYY-MM-DD'
        )}`
      : moment().format('YYYY-MM-DD')
    const columns = [
      {
        title: '日期',
        dataIndex: 'attendanceDate',
      },
      {
        title: '员工',
        dataIndex: 'name',
      },
      {
        title: '上班时间',
        dataIndex: 'punchInDate',
      },
      {
        title: '上班状态',
        dataIndex: 'punchInStatus',
      },
      {
        title: '上班打卡地址',
        dataIndex: 'punchInPosition',
        width: 280
      },
      {
        title: '下班时间',
        dataIndex: 'punchOutDate',
      },
      {
        title: '下班状态',
        dataIndex: 'punchOutStatus',
      },
      {
        title: '下班打卡地址',
        dataIndex: 'punchOutPosition',
        width: 280
      },
      {
        title: '总工时',
        dataIndex: 'duration',
      },
    ]
    return (
      <div>
        <div className="com-table-select-top-view">
          <RangePicker
            disabledDate={this.disabledDate}
            format="YYYY-MM-DD"
            placeholder={['开始时间', '结束时间']}
            value={hackValue || pickerValue}
            onChange={this.onChange}
            onCalendarChange={this.onCalendarChange}
            onOpenChange={this.onOpenChange}
          />
          <Button
            type="primary"
            className="button-flex-left"
            onClick={this.onSearchEvent}
          >
            查询
          </Button>
          <Button type="default" className="button-flex-left">
            <a
              id="test"
              href={clickDownload(columns, list || [])}
              download={`考勤记录按日查看-${dateString}.csv`}
            >
              导出
            </a>
          </Button>
        </div>
        <Table
          rowKey="attendanceId"
          loading={isloading}
          bordered
          size="small"
          columns={columns}
          dataSource={list}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubAttendanceRecord/component/dayTable/dayTable.js